import gql from 'graphql-tag';

const GET_SERVICE_RUN_ROSTER_DRIVERS = gql`
	query getServiceRunRosterDrivers($date: String!) {
		getServiceRunRosterDrivers(date: $date) {
			employeeId
			employeeName
			workTenantName
			shifts {
				id
				startMinutes
				endMinutes
				area
				areaLabel
			}
			user {
				id
				firstname
				lastname
				phone
				defaultVehicle {
					id
					name
				}
				overrideMachinePhotoSchedule
				requireMachinePhotos
				machinesPhotosIntervalUnit
				machinesPhotosIntervalUnits

				overrideMarketPhotoSchedule
				requireMarketPhotos
				marketsPhotosIntervalUnit
				marketsPhotosIntervalUnits

				overrideHideFutureRunsFromDriversSetting
				hideFutureRunsFromDrivers

				overrideDefaultCashCollectionSetting
				defaultCashCollectionSetting
				defaultCashCollectionAbove
				userSitePermissions {
					id
					expiresAt
					sitePermission {
						id
						policy
					}
				}
			}
		}
	}
`;

export default GET_SERVICE_RUN_ROSTER_DRIVERS;
